import { create } from 'zustand';
import { customerRequestsService } from '../services/customerRequests/customerRequestsService';
import type { CustomerRequestDto } from '../services/customerRequests/types';
interface State {
  scope: string | null; restaurantId?: string; items: CustomerRequestDto[]; count: number; loading: boolean; error: boolean; generation: number;
  setScope: (scope: string | null, restaurantId?: string) => void;
  refresh: () => Promise<void>;
}
let inFlight: AbortController | null = null;
export const useCustomerRequestsStore = create<State>((set, get) => ({
  scope: null, items: [], count: 0, loading: false, error: false, generation: 0,
  setScope: (scope, restaurantId) => {
    if (get().scope === scope) return;
    inFlight?.abort();
    set(state => ({ scope, restaurantId, items: [], count: 0, error: false, loading: false, generation: state.generation + 1 }));
  },
  refresh: async () => {
    const { scope, restaurantId, generation } = get();
    if (!scope) return;
    inFlight?.abort();
    const controller = new AbortController(); inFlight = controller;
    set({ loading: true });
    try {
      const result = await customerRequestsService.pending(restaurantId, controller.signal);
      if (!controller.signal.aborted && get().generation === generation) set({ items: result.items, count: result.pendingCount, loading: false, error: false });
    } catch (error) {
      if (controller.signal.aborted || get().generation !== generation) return;
      set({ error: true, loading: false });
      throw error;
    }
  },
}));
